module.exports = __webpack_public_path__ + "img/emoji_44.1a7c9cdc.png";